import ImagingViewer from "../ImagingViewer";

/** The `measures/imaging-endoscopy` route: ImagingViewer locked to modality "Endoscopy". */
export default function ImagingViewerEndoscopy() {
  return <ImagingViewer modality="Endoscopy" />;
}
